import { Routes, Route } from "react-router-dom";

import Home from "../pages/website/Home.jsx";
import AboutUs from "../pages/website/AboutUs.jsx";
import Earn from "../pages/website/Earn.jsx";
import StoreBank from "../pages/website/StoreBank.jsx";
import Pricing from "../pages/website/Pricing.jsx";
import ContactUs from "../pages/website/ContactUs.jsx";
import Rules from "../pages/website/Rules.jsx";
import FittingRoom from "../pages/website/FittingRoom.jsx";

import LoginPage from "../pages/panel/LoginPage.jsx";
import PanelUser from "../pages/panel/user/PanelUser.jsx";
import AdminPanel from "../pages/AdminPanel/panelAdmin.jsx";
import PanelSupporter from "../pages/supporterPanel/panelSupporter.jsx";

import PaymentFailed from "../pages/payment/PaymentFailed.jsx";
import PaymentSuccess from "../pages/payment/PaymentSuccess.jsx";

import StoreRenderer from "../pages/StoreRenderer.jsx";
import NotFound from "../pages/NotFound.jsx";

import AdminRoute from "./AdminRoute.jsx";
import SupporterRoute from "./SupporterRoute.jsx";
import PanelUserProMajazi from "../pages/proMajazi/user/panelUserProMajazi.jsx";

import ProductsSearch from "../pages/website/ProductsSearch.jsx";

const CUSTOM_STORE_DOMAINS = new Set([
  "arayeshiarosshik.ir",
  "www.arayeshiarosshik.ir",
]);

const AppRoutes = () => {
  const host = window.location.hostname.toLowerCase();
  const isCustomDomain = CUSTOM_STORE_DOMAINS.has(host);

  return (
    <Routes>
      {/* وقتی دامنه اختصاصی است، کل سایت باید فروشگاه باشد */}
      {isCustomDomain ? (
        <>
          <Route path="/*" element={<StoreRenderer />} />
        </>
      ) : (
        <>
          {/* Website */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/earn" element={<Earn />} />
          <Route path="/shops" element={<StoreBank />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/searchproduct" element={<ProductsSearch />} />
          <Route path="/fittingroom" element={<FittingRoom />} />

          {/* Authentication */}
          <Route path="/panel/login" element={<LoginPage />} />

          {/* User panel */}
          <Route path="/panel/user/*" element={<PanelUser />} />

          {/* Admin panel - Protected */}
          <Route element={<AdminRoute />}>
            <Route path="/panel/admin/*" element={<AdminPanel />} />
          </Route>

          {/* Supporter panel - Protected */}
          <Route element={<SupporterRoute />}>
            <Route path="/panel/supporter/*" element={<PanelSupporter />} />
          </Route>

          {/* pro majazi panel - Protected */}
          <Route path="/panel/pro-majazi/*" element={<PanelUserProMajazi />} />

          {/* Store routes (مثل قبل) */}
          <Route path="/:slug/*" element={<StoreRenderer />} />

          <Route path="/payment/failed" element={<PaymentFailed />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />

          <Route path="*" element={<NotFound />} />
        </>
      )}
    </Routes>
  );
};

export default AppRoutes;
